import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { Image } from '@openedx/paragon';

import './index.scss';
import { useT } from '../../../context/LanguageContext';

const MediumLayout = () => {
  const { t } = useT();

  return (
    <div
      className="w-100 mb-3 bg-primary-500 banner__image medium-layout"
      style={{ backgroundImage: `url(${getConfig().BANNER_IMAGE_MEDIUM})` }}
    >
      <a href="/">
        <Image className="company-logo" alt={getConfig().SITE_NAME} src={getConfig().LOGO_WHITE_URL} />
      </a>
      <div className="ml-5 pb-4 pt-4">
        <h1 className="display-2 banner__heading">
          <span className="text-light-500">
            {t('your.career.turning.point')}{' '}
          </span>
          <span className="text-warning-300 d-inline-block">
            {t('is.here')}
          </span>
        </h1>
      </div>
    </div>
  );
};

export default MediumLayout;
